import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import * as localForage from 'localforage';


@Injectable()

export class GuestGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    //if (localStorage.getItem('_user')) {
    //    // logged in so return true
    //    console.log('auth.guard true')
    //    return true;
    //}
    if (localForage.getItem('_user')) {
      // logged in so return true
      console.log('auth.guard true');
      return true;
    }
    console.log('auth.guard false')
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/signin']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts